'use client';

import { AuthContext, type AuthContextValue } from 'AuthBff/auth-provider';
import { ConfigError } from 'AuthSdk/errors';
import { useContext } from 'react';

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new ConfigError('useAuth outside an AuthProvider');
  return ctx;
};
